import {NgModule} from "@angular/core";
import {SharedModule} from "../../../shared.module";
import {ProductResultsCardComponent} from "./product-results-card.component";
import {ProductSelectionModule} from "../../product-selection/product-selection.module";
import {ProductBuyBoxModule} from "../buy-box/product-buy-box.module";

@NgModule({
    imports: [SharedModule, ProductSelectionModule, ProductBuyBoxModule],
    declarations: [ProductResultsCardComponent],
    exports: [ProductResultsCardComponent]
})
export class ProductResultsCardModule { }
